// import lib(s)
import React, { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import styles from "./AllLeadView.module.css"
import { useTheme } from "@emotion/react"

import { useNavigate, useParams } from "react-router-dom"

import { selectLead } from '../../Annotator/AnnotatorSlice'

import FullWidthECGPreview from "../../../components/FullWidthECGPreview"
import applyInversion from "../../../utils/applyInversion"
import { computeRmsWaveform } from "../../../utils/rmsWaveform"

const AllLeadView = (props) => {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const urlParams = useParams()
	const theme = useTheme()

	// Annotator Data
	const AnnotatorData = useSelector((state) => state.Annotator)
	const ecg = AnnotatorData.filtered
	const totalLeads = AnnotatorData.leadCount
	const inverted = AnnotatorData.settings.inverted
	const samples = useMemo(
		() => (inverted ? applyInversion(ecg.samples) : ecg.samples),
		[inverted, ecg.samples],
	)
	// RMS-across-leads trace over the full recording; peaks during QRS
	// complexes because leads' signals are largest and least cancelling then.
	const rmsWaveform = useMemo(() => computeRmsWaveform(samples), [samples])


	const HeightPerStrip = 200
	const AllLeadWidth = (ecg.duration*100) * AnnotatorData.settings.scale
	// +1 strip of vertical room for the RMS trace rendered below the leads.
	const AllLeadHeight = ((totalLeads + 1)*HeightPerStrip + 1) * AnnotatorData.settings.scale
	return (
			<div style={{height: `${AllLeadHeight}px`, width: `${AllLeadWidth}px`, position: "relative" }} className={styles.RightColumn}>
				{Object.keys(samples).map((lead) => (
					<FullWidthECGPreview
						key={lead}
						ecgTitle = {lead}
						enableBeats = {true}
						scale = {AnnotatorData.settings.scale}
						sample = {samples[lead]}
						beats = {AnnotatorData.annotations.beats}
						beatLabel = {AnnotatorData.annotations.labels.beats}
						seconds = {ecg.duration || 30}
						heightFactor = {2}
						mvSwing = {ecg.gain*2.5}
						onClick={()=>{
							dispatch(selectLead(lead))
							props.changeTab(2)
						}}
						style={{cursor: "pointer"}}
						renderTimeScaleFactor = {2}
						frequency={ecg.frequency}
					/>
				))}
				<FullWidthECGPreview
					ecgTitle="RMS"
					enableBeats={true}
					beats={AnnotatorData.annotations.beats}
					beatLabel={AnnotatorData.annotations.labels.beats}
					scale={AnnotatorData.settings.scale}
					sample={rmsWaveform}
					seconds={ecg.duration || 30}
					heightFactor={2}
					mvSwing={ecg.gain*2.5}
					renderTimeScaleFactor={2}
					frequency={ecg.frequency}
				/>
			</div>
	)
}


export default AllLeadView
